import { Box, Button, Container, Grid, IconButton, Switch } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useContext, useEffect, useState, useRef } from 'react';
import { CreateAddonValidationSchema } from '../../utils/Validations';
import { postRequest, putRequestWithToken } from '../../utils/ApiRequests';
import { GlobalContext } from '../../components/GlobalStateProvide/GlobalStateProvider';
import { useLocation, Link, useNavigate } from 'react-router-dom';
import FocusError from '../../components/FocusError/FocusError';
import ReusableLoader from "../../components/ReusableLoader/ReusableLoader";
import BackBtn from '../../components/backButton/BackBtn';
import { checkPermission } from '../../utils/userPermissions'
import Unauthorized from "../../components/unauthorized/Unauthorized";
import CircularProgress from '@mui/material/CircularProgress';
import RichTextEditor from 'react-rte';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const CreateRegion = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { handleSnackBar } = useContext(GlobalContext);
  const location = useLocation();

  const [dataById, setDataById] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [canCreate, setCanCreate] = useState(true);
  const [canDelete, setCanDelete] = useState(true);
  const [canUpdate, setCanUpdate] = useState(true);
  const [canRead, setCanRead] = useState(true);
  const [isAccess, setisAccess] = useState([]);
  const [jobCount, setJobCount] = useState(0);
  const [isIncludesValue, setisIncludesValue] = useState(true);
  const [contentError, setContentError] = useState(false);

  const [sector, setSector] = useState([]);
  // const [fetchingPincode, setfetchingPincode] = useState(false);
  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());


  const [initialValues, setInitialValues] = useState({
    name: "",
    isActive: true,
    coordinates: ["", "", "", ""]
  })
  const [edit, setEdit] = useState(false);

  // console.log(location, "this is location");


  const scrollTargetRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (values, { resetForm }) => {

    setContentError(false);
    setFormSubmitted(true);

    // Parse and validate coordinates
    const parsedCoordinates = values.coordinates
      .map(coord => {
        const parts = coord.trim().split(",");
        if (parts.length === 2) {
          const lat = parseFloat(parts[0].trim());
          const lng = parseFloat(parts[1].trim());
          if (!isNaN(lat) && !isNaN(lng)) {
            return [lng, lat]; // GeoJSON uses [longitude, latitude]
          }
        }
        return null;
      })
      .filter(coord => coord !== null);

    if (parsedCoordinates.length < 4) {
      handleSnackBar(true, "Please add at least 4 valid coordinates to create a polygon", "error");
      setFormSubmitted(false);
      return;
    }

    // Ensure first and last coordinates are the same to close the polygon
    if (parsedCoordinates[0][0] !== parsedCoordinates[parsedCoordinates.length - 1][0] ||
      parsedCoordinates[0][1] !== parsedCoordinates[parsedCoordinates.length - 1][1]) {
      parsedCoordinates[parsedCoordinates.length - 1] = parsedCoordinates[0];
    }

    let formData = {
      name: values.name,
      polygon: {
        type: "Polygon",
        coordinates: [parsedCoordinates]
      },
      isActive: values.isActive,
      metadata: {}
    };

    try {
      let res = edit ?
        await putRequestWithToken(`admin/regions/${dataById._id}`, formData) :
        await postRequest('admin/regions', formData);

      if (res.data.status === 'Success' || res.status === 201 || res.status === 200) {
        setFormSubmitted(false);
        if (!edit) {
          resetForm();
          handleSnackBar(true, res.data.msg || "Region created successfully", "success");
          setTimeout(() => {
            navigate('/regions');
          }, 1000);
        }
        else {
          handleSnackBar(true, res.data.msg || "Region updated successfully", "success");
          setTimeout(() => {
            navigate('/regions');
          }, 1000);
        }
      }
      else {
        setFormSubmitted(false);
        handleSnackBar(true, res.data.msg, "error")
      }
    } catch (err) {
      console.log(err);
      setFormSubmitted(false);
      handleSnackBar(true, err?.response?.data?.msg || err?.message, "error")
    }
  }

  const getEmployerById = async () => {
    setDataById(location.state)
  }

  const checkPermissionFunc = () => {
    const resourceToUpdate = "HC-Addon";
    const permissions = checkPermission(resourceToUpdate);
    setCanCreate(permissions.canCreate)
    setCanDelete(permissions.canDelete)
    setCanUpdate(permissions.canUpdate)
    setCanRead(permissions.canRead)
  }

  const againCheckPermissions = () => {
    // console.log("hello")
    const checkAccesInArray = localStorage.getItem("resourceNames");
    // console.log("resourceNames : " + checkAccesInArray);
    setisAccess(checkAccesInArray);
    isIncludes();
  }

  const isIncludes = () => {
    setisIncludesValue(isAccess.includes("HC-Addon"))
  }

  useEffect(() => {

    checkPermissionFunc();
    againCheckPermissions();
    if (location.state?._id) {
      getEmployerById()
    }
    else {
      setShowLoader(false);
    }

    if (location?.state?._id) {
      const { name = dataById?.name, isActive = true, polygon = {} } = dataById;
      const coordinates = polygon?.coordinates?.[0] || ["", "", "", ""];
      const formattedCoordinates = coordinates.map(coord => `${coord[1]}, ${coord[0]}`); // Convert [lng, lat] to lat, lng

      setInitialValues({
        name,
        isActive,
        coordinates: formattedCoordinates.length >= 4 ? formattedCoordinates : ["", "", "", ""]
      });
      setEdit(true);
    } else {
      setInitialValues({
        name: "",
        isActive: true,
        coordinates: ["", "", "", ""]
      });
      setEdit(false);
    }
  }, [location.state, dataById._id, isIncludesValue, sector])




  return (
    (isIncludesValue) ? <>
      {showLoader ? <ReusableLoader /> : <Box className="create-employer-section" ref={scrollTargetRef}>

        <Container>

          <Box className="create-employer">
            <Box className="headingPlusBackBtn">
              <BackBtn />
              <h1 className='formHeadings'>{edit ? "Update Region" : "Create Region"}</h1>
            </Box>
            <Box className="create-employer-form-wrapper">
              <Formik
                initialValues={initialValues}
                // validationSchema={CreateAddonValidationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ errors, values, setFieldValue, resetForm }) => (

                  <Form className="create-employer-form ">
                    <Box className="backgroundStyle">
                      <Grid container spacing={2} className='cstmFormGridEmployer'>

                        <Grid item xs={12} sm={12} md={8}>
                          <Box className="form-control" >
                            <label className="form-label" htmlFor="name"> Region Name <span className='must-fill-fields'>*</span></label>
                            <Field id="name"
                              type="text" placeholder="Enter Region Name"
                              name="name"
                              className="form-input" size="small"
                            />
                            {errors.name && <Box className="form-error">{errors.name}</Box>}

                          </Box>
                        </Grid>
                        <Grid item xs={12} sm={12} md={8}>
                          <Box className="form-control" >
                            <label className="form-label" htmlFor="isActive"> IsActive <span className='must-fill-fields'>*</span></label>
                            <Switch
                              id="isActive"
                              name="isActive"
                              checked={values.isActive}
                              onChange={(event) => {
                                setFieldValue("isActive", event.target.checked);
                              }}
                            />
                            {errors.isActive && <Box className="form-error">{errors.isActive}</Box>}

                          </Box>
                        </Grid>

                        {/* Coordinates Section */}
                        <Grid item xs={12} sm={12} md={8}>
                          <Box>
                            <label className="form-label"> Polygon Coordinates <span className='must-fill-fields'>*</span></label>
                            <Box sx={{ fontSize: "0.85rem", color: "#666", mb: 2 }}>
                              Format: latitude, longitude (e.g., 28.125161364200437, 77.31740546534544) - Minimum 4 coordinates required
                            </Box>

                            {values.coordinates?.map((coord, index) => {
                              const isLastCoordinate = index === values.coordinates.length - 1;
                              const isClosingPoint = isLastCoordinate && values.coordinates.length >= 4;

                              return (
                                <Box key={index}>
                                  <Box sx={{ display: "flex", gap: 2, mb: 1, alignItems: "flex-start" }}>
                                    <Box sx={{ flex: 1 }}>
                                      <input
                                        type="text"
                                        placeholder="e.g., 28.125161364200437, 77.31740546534544"
                                        value={isClosingPoint ? values.coordinates[0] : (coord || "")}
                                        onChange={(e) => {
                                          const newCoordinates = [...values.coordinates];
                                          newCoordinates[index] = e.target.value;
                                          // If editing the first coordinate, auto-sync with last
                                          if (index === 0) {
                                            newCoordinates[newCoordinates.length - 1] = e.target.value;
                                          }
                                          setFieldValue("coordinates", newCoordinates);
                                        }}
                                        className="form-input"
                                        style={{
                                          width: "100%",
                                          padding: "8px",
                                          borderRadius: "4px",
                                          border: "1px solid #ccc",
                                          ...(isClosingPoint && {
                                            backgroundColor: "#f5f5f5",
                                            borderColor: "#ff9800",
                                            borderWidth: "2px"
                                          })
                                        }}
                                        disabled={isClosingPoint}
                                      />
                                    </Box>
                                    {!isClosingPoint && values.coordinates.length > 4 && (
                                      <IconButton
                                        onClick={() => {
                                          const newCoordinates = values.coordinates.filter((_, i) => i !== index);
                                          setFieldValue("coordinates", newCoordinates);
                                        }}
                                        color="error"
                                        sx={{ mt: 1 }}
                                      >
                                        <DeleteIcon />
                                      </IconButton>
                                    )}
                                  </Box>
                                  {isClosingPoint && (
                                    <Box sx={{ fontSize: "0.75rem", color: "#ff9800", mb: 2, fontWeight: 500, ml: 1 }}>
                                      ⚠️ Closing point (auto-synced with first coordinate to complete the polygon loop)
                                    </Box>
                                  )}
                                </Box>
                              );
                            })}

                            {values.coordinates.length < 10 && (
                              <Button
                                variant="outlined"
                                startIcon={<AddIcon />}
                                onClick={() => {
                                  setFieldValue("coordinates", [...values.coordinates, ""]);
                                }}
                                sx={{ mt: 2 }}
                              >
                                Add Coordinate
                              </Button>
                            )}
                          </Box>
                        </Grid>

                      </Grid>

                    </Box>

                    <Box className="form-button-section">
                      <Link to='/addon'>
                        <Button className="form-button"
                          variant="contained"
                          onClick={() => {
                            resetForm();
                          }}
                          color="error"
                        >Cancel</Button>
                      </Link>

                      <Button className="form-button"
                        variant="contained"
                        type="submit"
                        color="success"
                        disabled={formSubmitted}
                      >
                        {formSubmitted ? <CircularProgress size={24} /> :
                          edit ? "Update" : "Create"}
                      </Button>

                    </Box>
                    <FocusError handleSnackBar={handleSnackBar} />
                  </Form>
                )}
              </Formik>
            </Box>
          </Box>
        </Container>

      </Box >}
    </> : (<Unauthorized />)

  )

}
export default CreateRegion;